import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { useChatBubbleContext } from '../ChatBubble.Context/index.es.js';

const ChatBubbleContent = ({ children })=>{
    const { author } = useChatBubbleContext();
    return jsx("div", {
        className: classNames('cb-chat-bubble-content', {
            user: author === 'user'
        }),
        children: children
    });
};

export { ChatBubbleContent };
//# sourceMappingURL=ChatBubble.Content.es.js.map
